

























import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import BorderBox from "@/components/UserInfo/BorderBox/BorderBox.vue";
import Loading from "@/components/Loading/Loading.vue";
import {
  GETTER_CURRENT_USER_MEDIA_LIST,
  UPDATE_CURRENT_POST_ID,
  GETTER_CURRENT_POST_ID,
  GETTER_CURRENT_POST_INFO,
  REQUEST_CURRENT_INS_USER_MEDIA_MORE
} from "@/store/constants/ins_media_types";
import { GETTER_CURRENT_USER_ID } from "@/store/constants/index_types";
import Event_bus from "@/utils/event_bus";
import PostGallerySwitch from "@/components/PostGallerySwitch/PostGallerySwitch.vue";
import Jsbridge from "@/jsbridge";
import ImgCache from "@/utils/img_cache/img_cache";
import { getCurrentRoute } from "@/plugins/navigation/routes";

@Component({
  components: { swiper, swiperSlide, BorderBox, Loading, PostGallerySwitch }
})
export default class SelectPost extends Vue {
  @Action(REQUEST_CURRENT_INS_USER_MEDIA_MORE)
  private requestMoreMedia: any;
  @Mutation(UPDATE_CURRENT_POST_ID)
  private updateCurrentPostId: any;
  @Getter(GETTER_CURRENT_USER_MEDIA_LIST)
  private currentMedia: any;
  @Getter(GETTER_CURRENT_POST_INFO)
  private currentPostInfo: any;
  @Getter(GETTER_CURRENT_POST_ID)
  private currentPostId: any;
  @Getter(GETTER_CURRENT_USER_ID)
  private currentUserId: any;

  private slideIndex = 0;
  private isLoadingMore = false; // 正在加载更多

  private needRefreshSlideContent: any = null; // 记录是否需要更新slide

  private cachePostId: any = null;

  private postList: any[] = [];

  // get postList() {
  //   return (this.currentMedia && this.currentMedia.ins_media_list) || [];
  // }

  get postListLength() {
    return this.postList && this.postList.length;
  }

  get swiperOption() {
    return {
      slidesPerView: 4,
      centeredSlides: true,
      slideToClickedSlide: true,
      observer: true,
      initialSlide: this.slideIndex,
      lazy: {
        loadPrevNextAmount: 3
      },
      virtual: {
        slides: this.postList,
        renderSlide: (slide: any, index: any) => {
          console.log("renderSlide");
          const slideIn = `
          <div class="post-item">
            <img id="${"render-slide-" + index}"
             class="post-img"
              οnerrοr="${this.imgErrorHandle(slide.display_url, index)}"
               src="${slide.display_url}"
                />
            ${
              this.isVideoPost(slide)
                ? ` <img
              class="video-tag-icon"
              src=${require("@/assets/icons-file/sku/movies_pic.png")}
            />`
                : this.isMultiplePost(slide)
                ? ` <img
              class="video-tag-icon"
              src=${require("@/assets/icons-file/sku/multi_pic.png")}
            />`
                : ""
            }
          </div>`;
          return `<div class="swiper-slide" key=${slide.id}>${slideIn}</div>`;
        }
      },
      on: {
        slideChange: async () => {
          console.log("slideChangeTransitionEnd");
          const swiperRef = this.getSwiperRef();
          if (swiperRef) {
            const activeIndex = swiperRef.activeIndex;
            if (activeIndex < this.postList.length) {
              const currentPost = this.postList[activeIndex];
              // 先改变缓存的post_id
              if (this.cachePostId !== currentPost.id) {
                // 及时更新了post_id触发监听改变，和缓存的post_id相同则不会触发多次slideTo
                console.log(
                  "slideChangeTransitionEnd 触发了updateCurrentPostId",
                  {
                    cachePostId: this.cachePostId,
                    currentPost: currentPost.id,
                    postList: this.postList
                  }
                );
                this.updateCurrentPostId(currentPost.id);
                this.cachePostId = currentPost.id;
              }
            }
            if (
              this.postListLength > 10 &&
              activeIndex === this.postListLength - 1
            ) {
              // 达到最后一个的时候再加载更多
              this.loadMorePost();
            }
          } else {
            console.log("not swiper get");
          }
        }
      }
    };
  }

  private async loadMorePost() {
    try {
      if (this.isLoadingMore) {
        return;
      }
      this.isLoadingMore = true;
      await this.requestMoreMedia();
      this.postList = (this.currentMedia && this.currentMedia.ins_media_list) || [];
    } catch (error) {
      //
      console.log("loadMorePost error:", error);
    } finally {
      this.isLoadingMore = false;
    }
  }

  get isVideo() {
    return this.currentPostInfo && this.currentPostInfo.is_video;
  }

  get likeCount() {
    return (this.currentPostInfo && this.currentPostInfo.like_count) || 0;
  }

  get commentCount() {
    return (this.currentPostInfo && this.currentPostInfo.comment_count) || 0;
  }

  get viewCount() {
    return (this.currentPostInfo && this.currentPostInfo.video_view_count) || 0;
  }

  get postSwiper() {
    return this.$refs.postSwiper && (this.$refs.postSwiper as any).swiper;
  }

  private getSwiperRef() {
    const refs: any = this.$refs;
    if (refs.postSwiper && refs.postSwiper.swiper) {
      return refs.postSwiper.swiper;
    } else {
      return null;
    }
  }

  private isVideoPost(post: any) {
    return post && post.is_video;
  }

  private isMultiplePost(post: any) {
    return post && post.media_type && post.media_type === 8;
  }

  private async imgErrorHandle(url: string, index: number) {
    try {
      if (ImgCache.getImgCache(url)) {
        this.$nextTick(() => {
          const dom: any = document.getElementById("render-slide-" + index);
          dom && (dom.src = ImgCache.getImgCache(url));
        });
      } else {
        this.$nextTick(() => {
          const dom: any = document.getElementById("render-slide-" + index);
          dom && (dom.style.visibility = "hidden");
        });
        const response: any = await Jsbridge.http({
          headers: {},
          url,
          method: "GET",
          timeout_interval: 5
        });
        const actual_src = "data:image/jpeg;base64," + response.data;
        this.$nextTick(() => {
          const dom: any = document.getElementById("render-slide-" + index);
          dom && (dom.style.visibility = "visible");
          dom && (dom.src = actual_src);
          ImgCache.setImgCache(url, actual_src);
        });
      }
    } catch (e) {
      console.log(
        "imgErrorHandle e",
        document.getElementById("render-slide-" + index) as any
      );
      (document.getElementById("render-slide-" + index) as any).style.display =
        "none";
    }
  }

  @Watch("currentPostId", { immediate: true })
  private watchCurrentPostIdChange(val: any, oldVal: any) {
    // 监听id的改变，避免重复渲染
    console.log("watchCurrentPostIdChange:", {
      val,
      oldVal,
      postList: this.postList
    });
    if (val !== oldVal) {
      // 缓存post_id
      this.cachePostId = val;
      this.postList = (this.currentMedia && this.currentMedia.ins_media_list) || [];
      // slide swiper
      const findIndex =
        this.postList &&
        this.postList.findIndex((item: any) => item.id === val);
      this.$nextTick(() => {
        const refs: any = this.$refs;
        if (findIndex > -1 && refs.postSwiper && refs.postSwiper.swiper) {
          refs.postSwiper.swiper.slideTo(findIndex);
        }
      })
    }
  }

  @Watch("currentUserId", { immediate: true })
  private listenCurrentUserId() {
    if (getCurrentRoute() && getCurrentRoute().name === "Likes") {
      this.postList =
        (this.currentMedia && this.currentMedia.ins_media_list) || [];
      console.log("this.postList:", this.postList);
    } else {
      this.needRefreshSlideContent = {
        media_list:
          (this.currentMedia && this.currentMedia.ins_media_list) || [],
        useMediaList: true,
        user_id: this.currentUserId
      };
      console.log("needRefreshSlideContent", this.needRefreshSlideContent);
    }
  }

  private setVirtualSlides(value: any) {
    try {
      console.log("setVirtualSlides", value, this.postSwiper);
      const { update_mode, media_list, user_id, useMediaList } = value;
      if (this.postSwiper && user_id === this.currentUserId) {
        // 更新的user_id和当前的user_id是一致的才能更新，避免静默的一些异步请求导致了更新不同步
        if (update_mode === "load_more") {
          this.postSwiper.virtual.appendSlide(media_list);
        } else {
          const mediaList = useMediaList
            ? media_list
            : (this.currentMedia && this.currentMedia.ins_media_list) || [];
          console.log("mediaList", mediaList);
          this.postList = mediaList;
          this.postSwiper.virtual.removeAllSlides();
          this.postSwiper.virtual.appendSlide([...mediaList]);
        }
      }
    } catch (error) {
      //
    }
  }

  private slideSwiper() {
    // 更新
  }

  private mounted() {
    Event_bus.$on("ins_media_list_change", async (val?: any) => {
      if (val) {
        if (getCurrentRoute() && getCurrentRoute().name === "Likes") {
          this.setVirtualSlides(val);
        } else {
          this.needRefreshSlideContent = val;
        }
      }
      this.slideSwiper();
    });
  }

  private activated() {
    if (this.needRefreshSlideContent) {
      this.setVirtualSlides(this.needRefreshSlideContent);
      this.needRefreshSlideContent = null;
    }
  }

  private beforeDestroy() {
    Event_bus.$off("ins_media_list_change");
  }
}
